// extracted by mini-css-extract-plugin
export default {"scrollArea":"A3TBX"};